import { Component, Host, HostBinding, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MarkdownModule } from 'ngx-markdown';

import type { FaqEntry } from '../faq.interfaces';

@Component({
  selector: 'app-faq-entry',
  standalone: true,
  imports: [MatExpansionModule, MarkdownModule],
  templateUrl: './faq-entry.component.html',
})
export class FaqEntryComponent {
  entry = input.required<FaqEntry>();
}
